import React from 'react';
import { createRoot } from 'react-dom/client';
import './i18n';
import { App } from './App';

const container = document.getElementById('root');
if (!container) throw new Error('#root not found');

createRoot(container).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
